import { withInstall } from '../../../utils/with-install'
import ThreeLightAmbient from './ThreeLightAmbient.vue'

export const ElAmapThreeLightAmbient = withInstall(ThreeLightAmbient)
export default ElAmapThreeLightAmbient
